'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeOnPageTriggerAction = undefined;

var _reduxActions = require('redux-actions');

var _timeOnPageTriggerActionTypes = require('../constants/timeOnPageTriggerActionTypes');

var addTimeOnPageTriggerAction = exports.addTimeOnPageTriggerAction = (0, _reduxActions.createAction)(_timeOnPageTriggerActionTypes.ADD_TIME_ON_PAGE_TRIGGER, function (timeoutId) {
  return { timeoutId: timeoutId };
});